import React from 'react';
import PropTypes from 'prop-types';
import BaseComponent from './BaseComponent';

class Title extends BaseComponent {
    render() {
        return (
            <div
                className={this.Styles.quizTitle}
            >
                <div
                    className={this.Styles.icon}
                 />
                <div
                    className={this.Styles.titlePrefix}
                >
                    QUIZ
                </div>
                <div
                    className={this.Styles.content}
                >
                    { this.props.text }
                </div>
            </div>
        );
    }
}

Title.displayName = 'Title';
Title.propTypes = {
    text: PropTypes.string.isRequired,
};

export default Title;



// WEBPACK FOOTER //
// ./components/QuizSet/Title.js